const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObstetrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3655 -0.9308 0.9308 0.3655 -4.2544 24.4474)",
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 15.805,
    cy: 15.344,
    rx: 12.85,
    ry: 12.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.805,26.334c-6.06,0-10.99-4.93-10.99-10.99c0-0.99,0.126-4.338,1.738-5.925 c0.112-0.127,1.061-1.144,2.419-0.892c1.594,0.296,3.016,2.201,4.228,5.66c0.053,0.152-0.027,0.319-0.179,0.373 c-0.153,0.053-0.319-0.027-0.373-0.179c-1.415-4.039-2.835-5.099-3.777-5.278C7.787,8.898,6.997,9.801,6.989,9.81L6.971,9.829 C5.813,10.96,5.4,13.42,5.4,15.344c0,5.737,4.668,10.405,10.405,10.405S26.21,21.082,26.21,15.344 c0-5.738-4.668-10.405-10.405-10.405c-2.778,0-5.514,1.17-7.507,3.21C8.186,8.265,8.001,8.267,7.885,8.154 C7.77,8.041,7.768,7.856,7.881,7.741c2.102-2.152,4.99-3.386,7.925-3.386c6.06,0,10.99,4.93,10.99,10.99 C26.795,21.404,21.865,26.334,15.805,26.334z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3C5",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.03,15.556c0,0-1.231-0.702-0.703-1.946 c0,0,0.158-0.664,1.045-0.885c0,0-0.09-2.646,2.668-2.925c0,0,3.181-0.514,4.034,2.563c0,0,0.985,3.34-1.564,4.296l-1.6,0.649 c0,0-0.971,3.528-3.172,4.606c0,0-2.468,1.531-4.904-0.51c0,0-2.132-1.653-0.125-4.945c0,0-1.38,2.706-2.585,2.33 c0,0-0.775-0.161-1.109-0.762c0,0-0.758-1.521,1.149-1.028c0,0-0.863-3.592,2.165-3.282c0,0,0.736,0.01,1.842,0.499 c0,0-1.024-2.336,0.311-2.836c0,0,1.423-0.55,1.567,0.998c0,0-0.273,1.062,0.035,2.204C15.085,14.581,15.231,15.151,16.03,15.556z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.67,9.268 c0,0.268-0.217,0.485-0.485,0.485c-0.268,0-0.485-0.217-0.485-0.485c0-0.268,0.217-0.485,0.485-0.485 C16.453,8.782,16.67,9,16.67,9.268z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 21.302,
    cy: 8.761,
    r: 0.485
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M23.686,18.098 c0,0.268-0.217,0.485-0.485,0.485c-0.268,0-0.485-0.217-0.485-0.485c0-0.268,0.217-0.485,0.485-0.485 C23.469,17.613,23.686,17.83,23.686,18.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.809,7.137 c0,0.268-0.217,0.485-0.485,0.485c-0.268,0-0.485-0.217-0.485-0.485s0.217-0.485,0.485-0.485 C12.592,6.651,12.809,6.869,12.809,7.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.496,23.415 c0,0.268-0.217,0.485-0.485,0.485c-0.268,0-0.485-0.217-0.485-0.485c0-0.268,0.217-0.485,0.485-0.485 C18.278,22.93,18.496,23.147,18.496,23.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.013,21.104 c0,0.268-0.217,0.485-0.485,0.485c-0.268,0-0.485-0.217-0.485-0.485s0.217-0.485,0.485-0.485 C9.796,20.619,10.013,20.837,10.013,21.104z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 8.294,
    cy: 12.148,
    r: 0.485
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M13.875,9.036c0,0.181-0.146,0.327-0.327,0.327s-0.327-0.146-0.327-0.327s0.146-0.327,0.327-0.327 S13.875,8.855,13.875,9.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.095,6.968c0,0.181-0.147,0.327-0.327,0.327s-0.327-0.146-0.327-0.327 c0-0.181,0.146-0.327,0.327-0.327S18.095,6.787,18.095,6.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.171,11.167c0,0.181-0.146,0.327-0.327,0.327s-0.327-0.146-0.327-0.327 c0-0.181,0.147-0.327,0.327-0.327S24.171,10.986,24.171,11.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M25.163,16.336c0,0.181-0.146,0.327-0.327,0.327c-0.181,0-0.327-0.146-0.327-0.327 c0-0.181,0.146-0.327,0.327-0.327C25.017,16.009,25.163,16.155,25.163,16.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M21.344,20.071c0,0.181-0.146,0.327-0.327,0.327c-0.181,0-0.327-0.146-0.327-0.327 c0-0.181,0.146-0.327,0.327-0.327C21.198,19.744,21.344,19.89,21.344,20.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M14.212,24.674c0,0.181-0.146,0.327-0.327,0.327c-0.181,0-0.327-0.146-0.327-0.327 s0.146-0.327,0.327-0.327C14.066,24.347,14.212,24.494,14.212,24.674z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.146,
    y: 22.044,
    transform: "matrix(0.8124 -0.5831 0.5831 0.8124 -10.0975 16.6426)",
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.34,
    height: 3.94
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.681,18.276 c1.291,1.799,0.879,4.303-0.919,5.594c-1.799,1.291-4.303,0.879-5.594-0.919c-1.291-1.799-0.879-4.303,0.919-5.594 C17.886,16.065,20.39,16.477,21.681,18.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.131,18.628 c1.081,1.506,0.736,3.603-0.77,4.683c-1.506,1.081-3.603,0.736-4.683-0.77c-1.081-1.506-0.736-3.603,0.77-4.683 C17.953,16.778,20.05,17.123,21.131,18.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.32,24.983l3.51,4.89 c0.31,0.432,0.911,0.53,1.343,0.221c0.432-0.31,0.53-0.911,0.221-1.343l-3.51-4.89L20.32,24.983z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "20.246,19.896 19.18,19.896 19.18,18.83 17.716,18.83 17.716,19.896 16.65,19.896  16.65,21.361 17.716,21.361 17.716,22.427 19.18,22.427 19.18,21.361 20.246,21.361  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObstetrics);
export default __webpack_public_path__ + "static/media/obstetrics.944d7027f0f447164199ce8122f32428.svg";
export { ForwardRef as ReactComponent };